import RibbonButton from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { Alignment } from 'roosterjs-editor-types';
import { setAlignment } from 'roosterjs-editor-api';

const alignLeft: RibbonButton = {
    key: 'alignLeft',
    title: () => strings.alignLeft,
    imageSrc: require('../svg/alignleft.svg'),
    onExecute: (plugin, logUsage) => {
        setAlignment(plugin.getEditor(), Alignment.Left);
        logUsage('setAlignment', Alignment.Left);
    },
};

export default alignLeft;
